import React, { useState, Context, ReactElement, Component } from "react";

export interface table_list_modal_type {
    modal_title: string | JSX.Element[];
    modal_message: JSX.Element | undefined;
    modal_ok_button: boolean;
    action: number; //新增0 修改1 刪除2
    visible: boolean;
    is_config: boolean;
    is_logs: boolean;
    is_web_kubectl: boolean;
    kubectl_app_cluster?: string;
    kubectl_app_namespace?: string;
    quota_selected: string | undefined;
    is_details: boolean;
    is_yaml: boolean;
    is_initialization: boolean;
    is_scale_replica: boolean;
    is_edit_yaml: boolean;
    is_sure_edit: boolean;
    is_view_yaml: boolean;
    origin: string | undefined;
    is_delete_pod: boolean;
    is_unassign_quota: boolean;
    logs_data: any;
    is_restartLogs: boolean;
    pv_yaml_data: any;
  }

const TableListModalTypeContext: Context<[table_list_modal_type, React.Dispatch<React.SetStateAction<table_list_modal_type>>]> = React.createContext<[table_list_modal_type, React.Dispatch<React.SetStateAction<table_list_modal_type>>]>([{ visible: false } as table_list_modal_type, (_value: any) => { }]);

const TableListModalTypeProvider: (props: any) => ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null = (props: any): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null => {
    const [table_list_modal, set_table_list_modal] = useState({ visible: false } as table_list_modal_type);
    return (
        <TableListModalTypeContext.Provider value={[table_list_modal, set_table_list_modal]}>
            {props.children}
        </TableListModalTypeContext.Provider>
    )
}

export { TableListModalTypeContext, TableListModalTypeProvider };